import React from 'react';
import {Tooltip, TooltipProvider, TooltipTrigger, TooltipContent} from "../../../../shadCn/components/ui/tooltip";

const RentalAssetNameRenderer = ({keys, data, item}) => {
    const name = item?.asset ? item.asset?.name : item?.assetName ? item.assetName : "";
    const deleted = item?.asset?.isRemoved ?? false;
    return (
        <>
            {!deleted ?
                <div>{name}</div>
                :
                <TooltipProvider delayDuration={100}>
                    <Tooltip>
                        <TooltipTrigger>
                            <div className={'line-through w-full'}>
                                {name}
                            </div>
                        </TooltipTrigger>
                        <TooltipContent>
                            삭제된 자산입니다.
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            }
        </>
    );
};

export default RentalAssetNameRenderer;